<template>
  <input-field
    class="form-time--input"
    type="date"
    input="MdsInput"
    :label="label"
    :value="startDate"
    :min="minMaxDates.min"
    @input="$emit('input', { startDay: $event })"
    @error="$emit('validDate', $event)"
  />
</template>

<script>
import { format } from 'date-fns-tz'
import InputField from '@/components/frequencyModal/frequencies/helpers/InputField.vue'

export default {
  name: 'StartDate',
  components: {
    InputField,
  },
  props: {
    label: {
      type: String,
      default: 'Start Date',
    },
    startDate: {
      type: String,
      default: '',
    },
  },
  watch: {
    startDate(value) {
      this.$emit('input', {
        startDay: value,
      })
    },
  },
  computed: {
    // If in the future we want to add a min and max date for the Schedule's Start date, we must use this computed to generate the values.
    minMaxDates() {
      const min = format(new Date(), 'yyyy-MM-dd')
      return {
        min: min,
        max: '2028-12-31',
      }
    },
  },
}
</script>
